module.exports = __webpack_public_path__ + "img/service_icon.9d4bf2f2.png";